import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const SIdebar = ({local}) => {
    AOS.init({
      duration: 2000,
    });
    return (
        <div className="sidebar" data-aos="fade-right">
          <Link to='/' className={`fa fa-home ${local === '/' ? 'active' : null}`}> HOME</Link>
          <Link to='/sobre' className={`fa fa-search link ${local === '/sobre' ? 'active' : null}`}> SOBRE</Link>
          <Link to='/contato' className={`fa fa-search link ${local === '/contato' ? 'active': null}`}> CONTATO</Link>
          <Link to='/projetos' className={`fa fa-search link ${local === '/projetos' ? 'active' : null}`}> PROJ.REACT</Link>
          <Link to='/angular' className={`fa fa-search link ${local === '/angular' ? 'active' : null}`}> PROJ.ANGULAR</Link>
          <Link to='/videos' className={`fa fa-search link ${local === '/videos' ? 'active' : null}`}> VIDEOS</Link>
        </div>
    )
  
}

export default SIdebar;
